export function createPlatformMiddleware(to, from, next) {
  if (!from.name && to.name === "platform-create") {
    next({ name: "Home", replace: true });
    return;
  }
  next();
}
